import {environment} from '../../../environments/environment';
export const apiUrl = environment.apiUrl;








// WEBPACK FOOTER //
// C:/Clients/rent-hero/web-application/src/app/_shared/config/api.config.ts